/* Arian Leather v2: header behaviours. No framework, no dependencies. */
(function () {
  'use strict';

  var scrim = document.querySelector('[data-scrim]');
  var drawer = document.querySelector('[data-drawer]');
  var openers = document.querySelectorAll('[data-drawer-open]');
  var lastFocus = null;

  function setScrim(on) {
    if (!scrim) return;
    scrim.hidden = false;
    scrim.setAttribute('data-open', on ? 'true' : 'false');
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('data-open', 'true');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setScrim(true);
    document.documentElement.style.overflow = 'hidden';
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setScrim(false);
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  openers.forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (scrim) scrim.addEventListener('click', closeDrawer);

  /* Mega menu: the top-level item is a link to its own collection, so a click or Enter navigates there.
     The panel opens on hover (with a short delay) or on keyboard focus; it closes on Escape or when focus leaves. */
  var items = document.querySelectorAll('[data-mega-item]');
  var hoverTimer = null;
  function closeAllMega(except) {
    items.forEach(function (item) {
      if (item === except) return;
      var t = item.querySelector('[data-mega-toggle]');
      var p = item.querySelector('[data-mega-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    });
  }
  items.forEach(function (item) {
    var toggle = item.querySelector('[data-mega-toggle]');
    var panel = item.querySelector('[data-mega-panel]');
    if (!toggle || !panel) return;
    function open() { closeAllMega(item); toggle.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
    function close() { toggle.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    toggle.addEventListener('focus', open);
    item.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(open, 150); });
    item.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(close, 200); });
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
  });

  /* Country and language dialog */
  var dialog = document.getElementById('LocalizationDialog');
  document.querySelectorAll('[data-localization-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (dialog && typeof dialog.showModal === 'function') dialog.showModal(); });
  });
  document.querySelectorAll('[data-localization-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (dialog) dialog.close(); });
  });
  if (dialog) dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });

  /* Cookie banner re-open (Shopify's consent banner) */
  document.querySelectorAll('[data-reshow-consent]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
        window.Shopify.customerPrivacy.showPreferences();
      } else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          if (window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences) window.Shopify.customerPrivacy.showPreferences();
        });
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeAllMega();
  });
})();

/* ===== Product page: variant selection, gallery, add to bag ===== */
(function () {
  'use strict';
  var section = document.querySelector('[data-product-section]');
  if (!section) return;
  var dataEl = document.querySelector('[data-product-json]');
  var product = dataEl ? JSON.parse(dataEl.textContent) : null;
  var form = section.querySelector('[data-product-form]');
  var idInput = section.querySelector('[data-variant-id]');
  var priceEl = section.querySelector('[data-price]');
  var addBtn = section.querySelector('[data-add-to-cart]');
  var addLabel = section.querySelector('[data-add-label]');
  var availEl = section.querySelector('[data-availability]');
  var errEl = section.querySelector('[data-form-error]');
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  };
  var t = function (key, fallback) { return (window.theme && window.theme.strings && window.theme.strings[key]) || fallback; };

  function selectedOptions() {
    var values = [];
    section.querySelectorAll('[data-option-input]:checked').forEach(function (i) { values[Number(i.getAttribute('data-option-input'))] = i.value; });
    return values;
  }
  function findVariant(values) {
    if (!product) return null;
    return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); }) || null;
  }
  function updateChips() {
    section.querySelectorAll('[data-option-input]').forEach(function (input) {
      var chip = input.nextElementSibling;
      if (!chip) return;
      var on = input.checked;
      if (chip.classList.contains('al-swatch')) chip.classList.toggle('al-swatch--on', on);
      else chip.classList.toggle('al-pill--on', on);
      var idx = input.getAttribute('data-option-input');
      if (on) { var lbl = section.querySelector('[data-option-label="' + idx + '"]'); if (lbl) lbl.textContent = input.value; }
    });
  }
  var stickyPrice = section.querySelector('[data-sticky-price]');
  var stickyBtn = section.querySelector('[data-sticky-submit]');
  var stickyLabel = section.querySelector('[data-sticky-label]');
  var restock = section.querySelector('[data-restock]');
  var restockVariant = section.querySelector('[data-restock-variant]');
  function render(variant) {
    updateChips();
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; }
      if (addLabel) addLabel.textContent = t('unavailable', 'Unavailable');
      if (stickyBtn) stickyBtn.disabled = true;
      if (stickyLabel) stickyLabel.textContent = t('unavailable', 'Unavailable');
      if (restock) restock.hidden = true;
      return;
    }
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (stickyBtn) stickyBtn.disabled = !variant.available;
    if (stickyLabel) stickyLabel.textContent = variant.available ? t('add_to_bag', 'Add to bag') : t('sold_out', 'Sold out');
    if (restock) restock.hidden = !!variant.available;
    if (restockVariant) restockVariant.value = variant.title || '';
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (addBtn) addBtn.disabled = !variant.available;
    if (addLabel) addLabel.textContent = variant.available ? t('add_to_bag', 'Add to bag') + ' · ' + money(variant.price) : t('sold_out', 'Sold out');
    if (availEl && availEl.getAttribute('data-custom') !== 'true') {
      availEl.innerHTML = variant.available
        ? '<span class="al-badge al-badge--ok">' + t('in_stock', 'In stock') + '</span><span class="al-small">' + t('delivery_note', '') + '</span>'
        : '<span class="al-badge">' + t('sold_out', 'Sold out') + '</span><span class="al-small">' + t('restock_note', '') + '</span>';
    }
    if (variant.featured_media && variant.featured_media.position) showMedia(variant.featured_media.position - 1);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
    }
  }
  section.querySelectorAll('[data-option-input]').forEach(function (i) { i.addEventListener('change', function () { render(findVariant(selectedOptions())); }); });

  function showMedia(index) {
    section.querySelectorAll('[data-main-media] img').forEach(function (img) { img.hidden = Number(img.getAttribute('data-media-index')) !== index; });
    section.querySelectorAll('[data-thumb]').forEach(function (b) {
      var on = Number(b.getAttribute('data-thumb')) === index;
      b.style.border = on ? '1px solid var(--ivory)' : '';
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }
  section.querySelectorAll('[data-thumb]').forEach(function (b) { b.addEventListener('click', function () { showMedia(Number(b.getAttribute('data-thumb'))); }); });

  function toast(message) {
    var el = document.createElement('div');
    el.className = 'al-toast'; el.setAttribute('role', 'status');
    el.style.position = 'fixed';
    el.innerHTML = '<span style="font-size:14px"><span style="color:var(--ok)">' + message + '</span></span><a href="/cart" class="al-link" style="font-size:11px;margin-left:auto;white-space:nowrap">' + t('view_bag', 'View bag') + '</a>';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    });
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (addBtn) addBtn.disabled = true;
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (addBtn) addBtn.disabled = false;
          if (!res.ok) { if (errEl) { errEl.textContent = res.body.description || res.body.message || 'Could not add to bag.'; errEl.hidden = false; } return; }
          if (!document.querySelector('[data-cart-drawer]')) toast(t('added', 'Added to your bag'));
          refreshCount();
          document.dispatchEvent(new CustomEvent('al:cart:added', { detail: res.body }));
        })
        .catch(function () { if (addBtn) addBtn.disabled = false; if (errEl) { errEl.textContent = 'Could not add to bag. Please try again.'; errEl.hidden = false; } });
    });
  }

  /* Sticky add-to-bag bar on phones: shows once the main button has scrolled out of view */
  var sticky = section.querySelector('[data-sticky-bar]');
  var primary = section.querySelector('[data-primary-cta]');
  if (sticky && primary && 'IntersectionObserver' in window) {
    var stickyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.setAttribute('data-on', on ? 'true' : 'false');
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }, { threshold: 0 });
    stickyIO.observe(primary);
  }
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }
})();

/* ===== Contact-form results (review and back-in-stock forms): show the message for the form that was posted ===== */
(function () {
  'use strict';
  var posted = document.querySelectorAll('[data-posted-for]');
  if (/contact_posted=true/.test(window.location.search) && posted.length) {
    var id = (window.location.hash || '').replace('#', '');
    var target = null;
    posted.forEach(function (el) { if (el.getAttribute('data-posted-for') === id) target = el; });
    if (!target) target = posted[0];
    target.hidden = false;
    var wrap = target.closest('[data-restock]'); if (wrap) wrap.hidden = false;
    var det = target.closest('details'); if (det) det.open = true;
    target.scrollIntoView({ block: 'center' });
  }
  document.querySelectorAll('[data-form-errors]').forEach(function (el) {
    var det = el.closest('details'); if (det) det.open = true;
    var wrap = el.closest('[data-restock]'); if (wrap) wrap.hidden = false;
  });
})();

/* ===== Lazy builder drawings (home page band): masks load only when the band is near the viewport ===== */
(function () {
  'use strict';
  var figs = document.querySelectorAll('[data-lazy-mask]');
  if (!figs.length) return;
  function load(fig) {
    var m = fig.getAttribute('data-lazy-mask'); var i = fig.getAttribute('data-lazy-ink'); var n = 0;
    function done() {
      if (++n < 2) return;
      fig.style.setProperty('--cz-mask', 'url("' + m + '")');
      if (i) fig.style.setProperty('--cz-ink-mask', 'url("' + i + '")');
      fig.classList.add('al-cz__fig--ready');
    }
    var a = new Image(); var b = new Image();
    a.onload = a.onerror = done; b.onload = b.onerror = done;
    a.src = m; b.src = i || m;
  }
  if (!('IntersectionObserver' in window)) { figs.forEach(load); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); load(en.target); } });
  }, { rootMargin: '600px 0px' });
  figs.forEach(function (f) { io.observe(f); });
})();

/* ===== Cart drawer: open on add, quantity changes, section re-render ===== */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-scrim]');
  function setScrim(on) { if (!scrim) return; scrim.hidden = false; scrim.setAttribute('data-open', on ? 'true' : 'false'); }
  function open() { if (!drawer) return; drawer.setAttribute('data-open', 'true'); setScrim(true); document.documentElement.style.overflow = 'hidden'; var c = drawer.querySelector('[data-cart-close]'); if (c) c.focus(); }
  function close() { if (!drawer) return; drawer.setAttribute('data-open', 'false'); setScrim(false); document.documentElement.style.overflow = ''; }
  function refresh(thenOpen) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer']; if (!html || !drawer) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-cart-drawer-inner]');
        if (inner) { drawer.innerHTML = ''; drawer.appendChild(inner); bind(); }
        if (thenOpen) open();
      });
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    });
  }
  function bind() {
    document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.querySelectorAll('[data-qty-change]').forEach(function (b) {
      b.addEventListener('click', function () {
        var qty = Number(b.getAttribute('data-qty-change')); var key = b.getAttribute('data-line-key');
        b.disabled = true;
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function () { if (document.querySelector('[data-cart-page]')) window.location.reload(); else refresh(false); });
      });
    });
  }
  bind();
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('al:cart:added', function () { refresh(true); });
  document.querySelectorAll('[data-cart-link]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (drawer && window.matchMedia('(min-width: 721px)').matches) { e.preventDefault(); refresh(true); } });
  });
})();

/* ===== Table of contents for long pages and guides ===== */
(function () {
  'use strict';
  var toc = document.querySelector('[data-toc]'); var prose = document.querySelector('[data-prose]');
  if (!toc || !prose) return;
  var heads = prose.querySelectorAll('h2');
  if (heads.length < 2) return;
  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'section-' + (i + 1);
    var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; toc.appendChild(a);
  });
  toc.hidden = false;
  var links = toc.querySelectorAll('a');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { links.forEach(function (l) { l.classList.toggle('al-on', l.getAttribute('href') === '#' + en.target.id); }); } });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
})();

/* terms consent before checkout: the Checkout button only submits once the box is ticked; the consent is saved as a cart attribute so it shows on the order */
(function () {
  'use strict';
  function stamp() { return 'Yes · ' + new Date().toISOString().slice(0, 16).replace('T', ' ') + ' UTC'; }
  function sync(form) {
    var box = form.querySelector('[data-cart-terms]'); if (!box) return;
    var btn = form.querySelector('[name="checkout"]'); var attr = form.querySelector('[data-cart-terms-attr]'); var err = form.querySelector('[data-cart-terms-error]');
    if (btn) btn.setAttribute('aria-disabled', box.checked ? 'false' : 'true');
    if (attr) attr.value = box.checked ? stamp() : '';
    if (err && box.checked) err.hidden = true;
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-terms]')) return;
    var form = e.target.closest('form'); if (form) sync(form);
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Terms accepted': e.target.checked ? stamp() : '' } }) }).catch(function () {});
  });
  document.addEventListener('submit', function (e) {
    var form = e.target; var box = form.querySelector && form.querySelector('[data-cart-terms]'); if (!box) return;
    if (box.checked) { sync(form); return; }
    e.preventDefault();
    var err = form.querySelector('[data-cart-terms-error]'); if (err) err.hidden = false;
    box.focus({ preventScroll: true }); var wrap = form.querySelector('[data-cart-terms-wrap]'); if (wrap) wrap.scrollIntoView({ block: 'nearest' });
  }, true);
  document.querySelectorAll('form').forEach(sync);
})();
